import React from 'react';
import DynamicJEETest from './DynamicJEETest';
import { freeJEETestsMetadata } from '../../../data/freeJEETestData';

export default function FreeJEETest() {
  return <DynamicJEETest testsMetadata={freeJEETestsMetadata} />;
}
